import * as React from "react";
import { color } from "../../../styles/color";
import ClubOpts from "../../common/ClubOpts";
import DatePicker from "react-datepicker";
import { AutoComplete } from "antdv5";
import { PrinterOutlined } from "@ant-design/icons";
import Container from "../../common/Container";
import type { SetState, Fn } from "../../../client_types";

interface ReadOnlyInputProps {
  value: any;
  onClick: (e?: React.MouseEvent) => void;
}
const ReadonlyInput = React.forwardRef(
  ({ value, onClick }: ReadOnlyInputProps, ref: any) => (
    <div
      className="customInput"
      onClick={onClick}
      ref={ref}
      style={{ color: value ? "black" : `${color.default}` }}
    >
      {value ? value : "起始日期 - 结束日期"}
    </div>
  )
);

interface IProps {
  startDate: Date | null;
  endDate: Date | null;
  inputRef: any;
  searchValue: string;
  actionIDList: { value: string }[];
  setDateRange: React.Dispatch<
    React.SetStateAction<[Date | null, Date | null]>
  >;
  setSearchValue: SetState<string>;
  searchData: Fn;
  handleEnter: (e: React.KeyboardEvent, fn: Fn) => void;
  handleSearch: Fn;
  handleAuth: Fn;
  preventRefreshCount: (fn: Fn, count: number) => void;
  clubList: any[] | null;
}

const FunctionBox = ({
  startDate,
  endDate,
  searchData,
  inputRef,
  setDateRange,
  searchValue,
  actionIDList,
  setSearchValue,
  handleEnter,
  handleSearch,
  handleAuth,
  preventRefreshCount,
  clubList,
}: IProps) => {
  const [displayValue, setDisplayValue] = React.useState<string | null>(null);
  return (
    <Container>
      <div className="functionBox">
        <div className="searchBox">
          <ClubOpts clubList={clubList} />
          <div className="searchInput">
            <span className="dateOutter resized">
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                  setDateRange(update);
                }}
                fixedHeight
                minDate={startDate}
                maxDate={new Date()}
                dateFormat="yyyy-MM-dd"
                showPopperArrow={false}
                locale="zh"
                todayButton="今日"
                ref={inputRef}
                customInput={
                  <ReadonlyInput onClick={() => null} value="test" />
                }
                onInputClick={() => setDateRange([null, null])}
              />
            </span>
            <AutoComplete
              value={displayValue}
              options={actionIDList}
              onChange={(e) => {
                setSearchValue(e.split(" ")[1] ? e.split(" ")[1] : e.trim());
                setDisplayValue(e);
              }}
              placeholder="请输入扫描记录编号"
              filterOption={(inputValue: string, option: any) =>
                option.value.indexOf(inputValue) !== -1
              }
              onClick={() => (searchValue !== "" ? setSearchValue("") : false)}
              onKeyDown={(e: any) => handleEnter(e, handleSearch)}
            />
          </div>
          <div className="btnGroup">
            <button
              onClick={() => {
                preventRefreshCount(searchData, 3);
                handleAuth();
              }}
              disabled={startDate === null && searchValue === ""}
            >
              搜寻
            </button>
            <button
              onClick={() => {
                setDateRange([null, null]);
                setSearchValue("");
              }}
              disabled={startDate === null && searchValue === ""}
            >
              重置
            </button>
            <button onClick={() => window.print()}>
              <PrinterOutlined /> 打印本页
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default FunctionBox;
